import { Popover } from 'antd';
import { FC } from 'react';

import { KeyTextObj } from '~src/interfaces/translation.interface';
import SvgIcon from '~src/shared/SvgIcon';
import UrlText from '~src/shared/UrlText';
import MobileModal from '~src/shared/mobileModal/MobileModal';
import { Mobile, Web } from '~src/styles/containers.sc';

import { InfoIconBox } from './hoverImageInfo.sc';

interface Props {
  trigger?: JSX.Element;
  infoText: KeyTextObj | string;
  white?: boolean;
  notMobile?: boolean;
  maxWidth?: string;
}
const HoverInfoIcon: FC<Props> = ({ infoText, white = false, trigger, notMobile, maxWidth = '300' }: Props) => {
  let info: { key: string; txt: string };
  if (typeof infoText === 'string') {
    info = {
      key: 'from.server',
      txt: infoText,
    };
  } else {
    info = infoText;
  }

  const defaultTrigger = (
    <InfoIconBox className={white ? 'icon-white' : ''} data-translation={info.key}>
      <SvgIcon name="iconInfo" width="15px" />
    </InfoIconBox>
  );

  return (
    <>
      <Web className="hoverIcon">
        <Popover
          content={
            <div style={{ maxWidth }}>
              <UrlText text={info.txt} />
            </div>
          }
        >
          {trigger || defaultTrigger}
        </Popover>
      </Web>
      <Mobile>
        {notMobile ? (
          <>{trigger || defaultTrigger}</>
        ) : (
          <MobileModal
            trigger={trigger || defaultTrigger}
            content={<UrlText text={info.txt} />}
            header={trigger || defaultTrigger}
          />
        )}
      </Mobile>
    </>
  );
};

export default HoverInfoIcon;
